import React from "react";
import Switch from "../switch/Switch";
import { useTranslate } from "../../translate";
import ReCenterIcon from "./ReCenterIcon";
import PlusIcon from "./PlusIcon";
import MinusIcon from "./MinusIcon";
import { connect } from "../../store";
import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";

const motionTransition = {
    duration: 0.15,
    ease: "easeOut",
};

function MapControls(props) {
    const {
        reCenter,
        zoomIn,
        zoomOut,
        showAutoFollow,
        toggleIsAutoFollowActive,
        isAutoFollowActive,
        currentPlaceName,
        onSearchAreaClick,
        showReCenter,
        useTwoColumnLayout,
    } = props;
    const translate = useTranslate();
    const isDesktop = useTwoColumnLayout;
    return (
        <div className={classNames("trpr-map-controls-container trpr__hide-in-pdf-mode", { "is-desktop": isDesktop })}>
            <div className={classNames("trpr-map-controls", { "is-desktop": isDesktop })}>
                {showAutoFollow && (
                    <div className="trpr-map-controls__switch">
                        <Switch
                            id="trpr-map-controls-auto-follow"
                            checked={isAutoFollowActive}
                            onChange={toggleIsAutoFollowActive}
                            label={translate("Auto-follow")}
                        />
                    </div>
                )}
                <AnimatePresence>
                    {showReCenter && (
                        <motion.div
                            transition={motionTransition}
                            initial={{ opacity: 0, width: 0 }}
                            animate={{ opacity: 1, width: "auto" }}
                            exit={{ opacity: 0, width: 0 }}
                            className="trpr-map-controls__button-container"
                        >
                            <button type="button" className="trpr-map-controls__button is-placeholder">
                                <ReCenterIcon />
                            </button>
                            <button onClick={reCenter} type="button" className="trpr-map-controls__button is-real">
                                <ReCenterIcon />
                            </button>
                        </motion.div>
                    )}
                </AnimatePresence>
                {isDesktop && (
                    <>
                        <div onClick={zoomOut} className="trpr-map-controls__button-container">
                            <button type="button" className="trpr-map-controls__button">
                                <MinusIcon />
                            </button>
                        </div>
                        <div onClick={zoomIn} className="trpr-map-controls__button-container">
                            <button type="button" className="trpr-map-controls__button">
                                <PlusIcon />
                            </button>
                        </div>
                    </>
                )}
                <AnimatePresence>
                    {currentPlaceName && (
                        <motion.div
                            transition={motionTransition}
                            initial={{ opacity: 0, width: 0 }}
                            animate={{ opacity: 1, width: "auto" }}
                            exit={{ opacity: 0, width: 0 }}
                            className="trpr-map-controls__place-container"
                        >
                            <div className="trpr-map-controls__place is-placeholder">
                                <i className="trpr__icon-marker"></i>
                                <span>{currentPlaceName}</span>
                            </div>
                            <div className="trpr-map-controls__place is-real">
                                <i className="trpr__icon-marker"></i>
                                <span>{currentPlaceName}</span>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
                {onSearchAreaClick && (
                    <div className="trpr-map-controls__search-area-container">
                        <button className="trpr-map-controls__search-area" type="button" onClick={onSearchAreaClick}>
                            <i className="trpr__icon-search"></i>
                            <span>Search this area</span>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

MapControls.defaultProps = {
    onSearchAreaClick: null,
    showReCenter: true,
    setIsAutoFollowActive: () => {},
};

const mapStateToProps = ({ progressByDay, currentPlaceName }) => ({
    progressByDay,
    currentPlaceName,
});

const MapControlsWithStore = connect(mapStateToProps)(MapControls);
MapControlsWithStore.displayName = "MapControlsWithStore";

export default MapControlsWithStore;
